import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-bc7457dc")

_pushScopeId("data-v-bc7457dc")
const _hoisted_1 = { class: "bg-white container-fluid" }
const _hoisted_2 = { class: "container d-flex align-items-center py-3" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.paths, (path, index) => {
        return (_openBlock(), _createBlock(_component_router_link, {
          class: [path.class, "btn m-0 p-0"],
          to: path.to,
          key: path.label
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(path.label) + " ", 1),
            (index != _ctx.paths.length - 1)
              ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                  key: 0,
                  class: "mx-3",
                  icon: ['fas', 'chevron-right']
                }))
              : _createCommentVNode("", true)
          ]),
          _: 2
        }, 1032, ["class", "to"]))
      }), 128))
    ])
  ]))
})